import {alpha, hex, rgba} from 'lib/color'
import ColorPicker from 'lib/ui/ColorPicker'
import {BackgroundPickerProps} from 'lib/ui/form/BackgroundPicker'
import Slider from 'lib/ui/Slider'
import React from 'react'
import {
  isGradient,
  parseValues as parseGradientValues,
} from 'lib/ui/form/BackgroundPicker/GradientColorPicker'

export default function SolidColorPicker(props: BackgroundPickerProps) {
  const {background, onChange} = props

  const color = parseHex(background)
  const opacityPercent = alpha(background) * 100

  const handlePick = (pickedColor: string) => {
    if (!pickedColor) {
      // ColorPicker renders an empty color as its #FFFFFF fallback, so an
      // empty save would leave the stored value disagreeing with the input.
      onChange(toBackground('#FFFFFF', opacityPercent))
      return
    }

    onChange(toBackground(pickedColor, opacityPercent))
  }

  const handleOpacityChange = (newOpacityPercent: number) => {
    if (!color) {
      return
    }

    onChange(toBackground(color, newOpacityPercent))
  }

  return (
    <>
      <ColorPicker
        label="Color"
        disabled={props.disabled}
        color={color}
        onPick={handlePick}
        aria-label="solid background"
      />
      <Slider
        min={0}
        max={100}
        step={10}
        onChange={handleOpacityChange}
        valueLabelDisplay="off"
        label="Opacity"
        unit="%"
        value={opacityPercent}
        aria-label="background opacity"
      />
    </>
  )
}

function toBackground(color: string, opacityPercent: number) {
  const opacity = opacityPercent / 100
  return opacity === 1 ? color : rgba(color, opacity)
}

function parseHex(color?: string) {
  if (isGradient(color)) {
    const {color1} = parseGradientValues(color)
    return color1
  }

  return hex(color)
}
